import { IoMdClose } from 'react-icons/io'

import './modal.css'

const Modal = ({isObj, isModal, isSetModal}) => {

      if(isModal === false) return 

      const closeModal = () => {
            isSetModal(false)
      }
      
      return (
            <div className={isModal ? "modal_content show" : "modal_content"}>
                  <button className="close_modal" onClick={() => closeModal()}><IoMdClose /></button>
                  <div className="modal_inner">
                        <img src={isObj.image} alt={isObj.description} />
                  </div>
            </div>
      )
}

export default Modal
